<script>
import {mapGetters} from 'vuex'
export default {

    name: 'top-navbar',

    computed: {
        ...mapGetters({
            authUser: 'authUser'
        }),
    },

    data:()=> ({
        isOpen: false,
        offerOptions: [
            {
                id: 0,
                name: 'Create Offer',
                slug: 'offer-create',
                param:'create',
            },
            {
                id: 1,
                name: 'Create Landing Page',
                slug: 'landing-page-create',
                param:'create',
            },
            {
                id: 2,
                name: 'Create Stacked Offer',
                slug: 'stacked-offer-create',
            },
        ],
        quizOptions: [
            {
                id: 0,
                name: 'Create Quiz',
                slug: 'quiz-create',
            },
        ],
        clientOptions: [
            {
                id: 0,
                name: 'New Channel',
                slug: 'client-new',
            },
        ],
    }),

    watch:
    {
        '$route'()
        {
            this.isOpen = false
        }
    },

    methods: {
        openMenu(){
            this.isOpen = !this.isOpen
        },
        logout(){
            this.$store.dispatch('logout').then(()=>{
                this.$router.replace({
                    name:'login'
                })
            })
        },

        routerLink(value){
            if (value.param) {
                this.$router.push({
                    name: value.slug,
                    params: {slug: value.param}
                })
            } else {
                this.$router.push({
                    name: value.slug,
                })
            }
            this.openMenu()
        }
    }

}
</script>


<template lang="html">

    <div class="container-fluid top-navbar">
        <div class="row h-100">
            <div class="col-1 col-sm-2 orange-bg py-2 d-flex above-menu-overlay">
                <router-link class="text-white font-weight-bold align-self-center" :to="{ name: 'welcome'}">
                    ENGAGE
                </router-link>
            </div>
            <div class="col-10 col-sm-8 px-0 position-relative above-menu-overlay">
                <div @click="openMenu"
                class="d-inline-block h-100 py-2 text-white cp w-40px"
                :class="{'blackish-bg' : isOpen, 'orange-dark-bg' : !isOpen}">
                    <div class="d-flex h-100 align-items-center justify-content-center">
                        <i v-if="!isOpen" class="fal fa-bars"></i>
                        <i v-if="isOpen" class="fal fa-times"></i>
                    </div>
                </div>
                <div class="d-inline-block py-2 px-1">
                    <div class="d-flex align-items-center h-100">
                        <router-link class="mr-1" :to="{ name: 'welcome'}">
                            <i class="fas fa-sm fa-home"></i>
                        </router-link>

                        <i class="fal fa-xs fa-chevron-right mr-1"></i>

                        <span>{{ $route.name }}</span>
                    </div>

                </div>
                <div class="float-right h-100">
                        <div class="py-2 mr-3 d-inline-block h-100">
                            <div class="d-flex h-100 align-items-center justify-content-center">
                                <i class="fal fa-user-circle mr-1"></i>
                                <span>{{ authUser.name }}</span>
                            </div>
                        </div>
                        <div @click="logout" class="py-2 d-inline-block side-borders px-2 cp h-100">
                            <div class="d-flex h-100 align-items-center justify-content-center">
                                <i class="far fa-sign-out"></i>
                            </div>
                        </div>
                </div>
                <transition tag="div" name="menu">
                    <div v-if="isOpen" class="opened-menu">
                        <div class="container-fluid position-relative z-1000">
                            <div class="row">
                                <div class="menu-item">
                                    <div class="px-4 py-3 grey-bg font-weight-bold">
                                        Products
                                    </div>
                                    <div class="px-4 pt-2 pb-3">
                                        <ul class="sub-menu mb-3">
                                            <li>
                                                <router-link active-class="font-weight-bold" :to="{ name: 'offers-subpages', params: {slug: 'live', page: 1}}">
                                                    <span>
                                                        Offers
                                                    </span>
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link active-class="font-weight-bold" :to="{ name: 'stacked-offers-subpages', params: {slug: 'live', page: 1}}">
                                                    <span>
                                                        Stacked Offers
                                                    </span>
                                                </router-link>
                                            </li>
                                            <li>
                                                <router-link active-class="font-weight-bold" :to="{ name: 'landing-pages-subpages', params: {slug: 'live', page: 1}}">
                                                    <span>
                                                        Signup Pages
                                                    </span>
                                                </router-link>
                                            </li>
                                        </ul>
                                        <custom-multiselect
                                        class="navbar-multi"
                                        :options="offerOptions"
                                        modelLabel="name"
                                        @selected="routerLink"
                                        ></custom-multiselect>
                                    </div>
                                </div>
                                <div class="menu-item">
                                    <div class="px-4 py-3 grey-bg font-weight-bold">
                                        Tools
                                    </div>
                                    <div class="px-4 pt-2 pb-3">
                                        <custom-multiselect
                                        class="navbar-multi"
                                        :options="quizOptions"
                                        modelLabel="name"
                                        @selected="routerLink"
                                        ></custom-multiselect>
                                    </div>
                                </div>
                                <div class="menu-item">
                                    <div class="px-4 py-3 grey-bg font-weight-bold">
                                        Clients
                                    </div>
                                    <div class="px-4 pt-2 pb-3">
                                    </div>
                                </div>
                                <div class="menu-item">
                                    <div class="px-4 py-3 grey-bg font-weight-bold">
                                        Metric & Reports
                                    </div>
                                </div>
                                <div class="menu-item side-borders-grey-helper">
                                    <div class="px-4 py-3 grey-bg font-weight-bold">
                                        Channel settings
                                    </div>
                                    <div class="px-4 pt-2 pb-3">
                                        <ul class="sub-menu">
                                            <li>
                                                <router-link  active-class="font-weight-bold" :to="{ name: 'tracking-codes'}">
                                                    <span>
                                                        Settings
                                                    </span>
                                                </router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition >
            </div>
            <div class="col-1 col-sm-2 above-menu-overlay">

            </div>
            <div @click="openMenu" class="menu-overlay" v-if="isOpen"></div>
        </div>
    </div>

</template>



// WEBPACK FOOTER //
// src/components/layout-elements/nav.vue